import controller from './featured-events-phone-preview.controller';
import template from './featured-events-phone-preview.html';
import './featured-events-phone-preview.less';

const component = {
    template,
    bindings: {
        featuredEvents: '<',
    },
    controller: ['crImageService', controller],
};

export default component;
